<template>
<div>
  <div class="header-wrap">
    <div class="header">
      <div class="heard_top">
        <div class="heard_top_minwidth">
          <a><router-link to="/"><img src="../../assets/img/logo@-banner.png" alt="" class="heard_logo"></router-link></a>
          <ul class="heard_menu left">
            <li class="left"><router-link to="/">首页</router-link></li>
            <li id="production" class="left">
              <a>产品中心</a>
              <ul class="erjinav">
                <div class="displ">
                  <li><router-link to="/index/njb">能监宝</router-link></li>
                  <li><router-link to="/index/znyj">智能硬件</router-link></li>
                  <li><router-link to="/index/bdgj">运维工具</router-link></li>
                </div>
              </ul>
            </li>
            <li id="production" class="left">
              <a>智能运维</a>
              <ul class="erjinav">
                <div class="displ">
                  <li><router-link to="/index/dlyy">电力运维</router-link></li>
                  <li><router-link to="/index/nygl">能源管理</router-link></li>
                </div>
              </ul>
            </li>
            <li id="production" class="left">
              <a>合作共赢</a>
              <ul class="erjinav">
                <div class="displ">
                  <!-- <li><router-link to="/index/dgcy">电工0元创业</router-link></li> -->
                  <li><router-link to="/index/pphz">品牌加盟</router-link></li>
                  <li><router-link to="/index/zypphz">自有品牌合作</router-link></li>
                </div>
              </ul>
            </li>
            <li class="left"><router-link to="/index/xmal">项目案例</router-link></li>
            <li class="left"><router-link to="/index/yhdl">登录</router-link></li>
            <li class="left"><router-link to="/index/zc">注册</router-link></li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: 'headernav'
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/common/headernav.vue